<app-no-access *ngIf="hasAccess === false"></app-no-access>
@if (hasAccess) {
    <div class="container">
        <div class="header-container">
            <app-header></app-header>
        </div>
        <div class="body-container">
            <div class="side-menu-container" #sidebarRoot>
                <geaui-sidebar-v3 [devisionIconPath]="'assets/icons-v2/GEA-Codex-AppIcon-White.svg'"
                    [devisionName]="'CEH'"
                    [slimView]="slimView"
                    devisionIconBackgroundColor="var(--geaui-night-blue)"
                    [navigationItems]="navItems" 
                    [bottomNavigation]="bottomItems"
                    [class.sidebar-bottom-active]="activeSidebarList === 'bottom'"
                    data-sidebar-root>
                </geaui-sidebar-v3>
                @if (spanded) {
                    <div class="data-base-info">
                        <span>{{databaseService.connectDatabase.name}} - {{databaseService.connectDatabase.server}}</span>
                    </div>
                }
            </div>
            <div class="feature-container">
                <router-outlet></router-outlet>
            </div>
        </div>    
    </div>
    <geaui-snackbar-v3></geaui-snackbar-v3>
    <geaui-dialog-v2></geaui-dialog-v2>
}
